import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Dashboard() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    axios.get('/api/agents/report-monitor/status')
      .then(r => setStatus(r.data))
      .catch(() => {});
  }, []);

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Дашборд</div>
        <div className="page-subtitle">Общий статус платформы</div>
      </div>

      <div className="metrics-grid">
        <div className="metric-card success">
          <div className="metric-value">1</div>
          <div className="metric-label">Активных агентов</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">2</div>
          <div className="metric-label">В разработке</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">20</div>
          <div className="metric-label">Сотрудников</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">28</div>
          <div className="metric-label">Отелей</div>
        </div>
      </div>

      <div className="card">
        <div className="card-title">Статус агентов</div>
        <table className="table">
          <thead>
            <tr>
              <th>Агент</th>
              <th>Статус</th>
              <th>Следующий запуск</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>📋 Мониторинг отчётов</td>
              <td><span className="badge badge-success">● Активен</span></td>
              <td>
                {status?.schedule?.map(s => (
                  <div key={s.id} style={{fontSize: 13, color: '#8892A4'}}>
                    {s.name}: {new Date(s.next_run).toLocaleString('ru')}
                  </div>
                ))}
              </td>
            </tr>
            <tr>
              <td>🔄 Сверка TL/BK</td>
              <td><span className="badge badge-info">⏸ В разработке</span></td>
              <td>—</td>
            </tr>
            <tr>
              <td>📊 P&L анализ</td>
              <td><span className="badge badge-info">⏸ В разработке</span></td>
              <td>—</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
